import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { TwoFactorService } from '../../sign-in/sign-in-twofa/two-factor.service';
import { NgIf } from '@angular/common';
import { TwoFactorCredentials } from 'app/shared/model/security.model';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'twofa-instruction',
    templateUrl: './twofa-instruction.component.html',
    styleUrls: ['./twofa-instruction.component.scss'],
    imports: [
        NgIf,
    ],
})
export class TwofaInstructionComponent implements OnInit, OnDestroy {
    @Input() twoFactorActivationRequired: boolean;
    twofactorCredentials: TwoFactorCredentials | undefined;
    private _unsubscribeAll: Subject<any> = new Subject<any>();

    constructor(
        private _twoFactorService: TwoFactorService
    ) {}

    ngOnInit(): void {
        if (this.twoFactorActivationRequired) {
            this._twoFactorService.getTwoFactorCredentials().pipe(
                takeUntil(this._unsubscribeAll)
            ).subscribe((twofa) => {
                this.twofactorCredentials = twofa;
            });
        }
    }
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

}